import { EventEmitter } from 'ahooks/lib/useEventEmitter';
import { tUseSockets } from './Sockets.types';

export const SOCKET_URL = import.meta.env.VITE_SOCKET_URL as string;

export const CATCH_UP_SOCKET_THRESHOLD_MS = 5_000;
export const CATCH_UP_VISIBILITY_THRESHOLD_MS = 60_000;
export const CATCH_UP_DEBOUNCE_MS = 2_000;
export const SENTRY_ERROR_ESCALATION_THRESHOLD = 5;

export const SOCKET_CONFIG = {
  autoConnect: false,
  reconnection: true,
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 30000,
  randomizationFactor: 0.5,
  timeout: 20000,
  closeOnBeforeunload: true,
  // Websocket-only: polling disabled because the server (socketio.gateway.ts)
  // only accepts websocket transport. Polling fallback causes infinite retry
  // loops against the server's rejection.
  transports: ['websocket'],
  protocols: ['chat', 'superchat'],
};

export const initialState: tUseSockets = {
  chatInsertedEvent: new EventEmitter(),
  chatMessageBulkInsertFinishedEvent: new EventEmitter(),
  chatUpdatedEvent: new EventEmitter(),
  newQREvent: new EventEmitter(),
  metaMessengerConnectedEvent: new EventEmitter(),
  metaMessengerDisconnectedEvent: new EventEmitter(),
  tiktokAccountUpdateEvent: new EventEmitter(),
  workspaceAccountUpdateEvent: new EventEmitter(),
  leadUpdatedEvent: new EventEmitter(),
  leadDeletedEvent: new EventEmitter(),
  leadCreatedEvent: new EventEmitter(),
  leadMessageEvent: new EventEmitter(),
  profileUpdatedEvent: new EventEmitter(),
  funnelCreatedEvent: new EventEmitter(),
  funnelUpdatedEvent: new EventEmitter(),
  funnelDeletedEvent: new EventEmitter(),
  workspaceUsersUpdatedEvent: new EventEmitter(),
  workspaceUserUpdatedEvent: new EventEmitter(),
  workspaceUpdatedEvent: new EventEmitter(),
  challengeUpdatedEvent: new EventEmitter(),
  newNotificationEvent: new EventEmitter(),
  metaMessengerTemplateUpdate: new EventEmitter(),
  userSessionLogOutEmitter: new EventEmitter(),
  funnelDeletedProgressEvent: new EventEmitter(),
  billingQuotaUsageUpdated: new EventEmitter(),
  funnelLeadCountUpdated: new EventEmitter(),
  chatContactInsertedEvent: new EventEmitter(),
  chatContactUpdatedEvent: new EventEmitter(),
  createNewWapiTemplateEvent: new EventEmitter(),
  updateWapiTemplateEvent: new EventEmitter(),
  chatStatusUpdatedEvent: new EventEmitter(),
  billingMigrationStartedEvent: new EventEmitter(),
  billingMigrationFinishedEvent: new EventEmitter(),
  walletBalanceUpdatedEvent: new EventEmitter(),
  catchUpEvent: new EventEmitter(),
  slbProcessingEvent: new EventEmitter(),
  slbEscalatedEvent: new EventEmitter(),
  slbSessionStateChangedEvent: new EventEmitter(),
  slbStageAdvancedEvent: new EventEmitter(),
  slbFunnelMovedEvent: new EventEmitter(),
  slbSessionExpiredEvent: new EventEmitter(),
  slbSessionUpdatedEvent: new EventEmitter(),
  slbSessionGateFailedEvent: new EventEmitter(),
  slbEngagementChangedEvent: new EventEmitter(),
  accountHealthUpdatedEvent: new EventEmitter(),
  campaignDeletedEvent: new EventEmitter(),
  campaignCancelledEvent: new EventEmitter(),
  wapiNotificationCreatedEvent: new EventEmitter(),
  wapiAccountConnectionUpdatedEvent: new EventEmitter(),
  reactionInsertedEvent: new EventEmitter(),
  reactionRemovedEvent: new EventEmitter(),
  profilingStartedEvent: new EventEmitter(),
  profilingCompletedEvent: new EventEmitter(),
  syncContactsCreatedEvent: new EventEmitter(),
  syncContactsUpdatedEvent: new EventEmitter(),
  syncChunksCompleteEvent: new EventEmitter(),
  automationStateChangedEvent: new EventEmitter(),
};
